"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/components/ProfileListItem/index.tsx
var ProfileListItem_exports = {};
__export(ProfileListItem_exports, {
  ProfileListItem: () => ProfileListItem
});
module.exports = __toCommonJS(ProfileListItem_exports);

// src/components/ProfileListItem/ProfileListItem.tsx
var import_react = __toESM(require("react"));
var import_classnames = __toESM(require("classnames"));
var IMAGE_MULTI_MAX = 3;
function ProfileListItem({
  name,
  imgUrl,
  date,
  subtitle,
  icons,
  onClick,
  active,
  className = "",
  activeHighlightBgColorClassName = "v2-bg-blue-500",
  iconsClassName,
  rightElement,
  imgClassName
}) {
  const profileImage = (0, import_react.useCallback)(
    (url, style = {}, index = IMAGE_MULTI_MAX) => {
      if (Array.isArray(url) && url.length === 1) {
        url = url[0];
      }
      if (typeof url === "string") {
        return /* @__PURE__ */ import_react.default.createElement(
          "img",
          {
            key: index,
            src: url,
            className: (0, import_classnames.default)(
              "v2-w-[50px] v2-h-[50px] v2-rounded-full",
              imgClassName
            ),
            style: __spreadValues({ zIndex: index }, style)
          }
        );
      }
      return /* @__PURE__ */ import_react.default.createElement("div", { className: "v2-flex v2-relative v2-min-w-[58px]" }, url.slice(0, IMAGE_MULTI_MAX).map(
        (image) => profileImage(
          image,
          { position: "absolute", left: index * index + 2 },
          index--
        )
      ));
    },
    []
  );
  return /* @__PURE__ */ import_react.default.createElement(
    "div",
    {
      className: (0, import_classnames.default)(
        "v2-flex v2-h-[70px] v2-w-full v2-bg-white hover:v2-bg-neutral-50 v2-cursor-pointer v2-justify-between",
        className,
        {
          "!v2-bg-neutral-50": active
        }
      ),
      onClick
    },
    /* @__PURE__ */ import_react.default.createElement("div", { className: "v2-flex v2-w-full v2-overflow-hidden" }, /* @__PURE__ */ import_react.default.createElement(
      "div",
      {
        className: (0, import_classnames.default)("v2-w-[5px]", {
          [activeHighlightBgColorClassName]: active
        })
      }
    ), /* @__PURE__ */ import_react.default.createElement("div", { className: "v2-py-2.5 v2-pl-2.5 v2-min-w-fit" }, profileImage(imgUrl)), /* @__PURE__ */ import_react.default.createElement("div", { className: "v2-flex v2-flex-col v2-self-center v2-overflow-hidden v2-mx-2.5" }, /* @__PURE__ */ import_react.default.createElement("span", { className: "v2-text-neutral-900 v2-overflow-hidden v2-text-ellipsis v2-whitespace-nowrap" }, name), /* @__PURE__ */ import_react.default.createElement("span", { className: "v2-text-xs v2-text-neutral-500 v2-overflow-hidden v2-text-ellipsis v2-whitespace-nowrap" }, subtitle), /* @__PURE__ */ import_react.default.createElement("span", { className: (0, import_classnames.default)("v2-text-[10px] v2-mt-0.5", iconsClassName) }, icons))),
    rightElement,
    /* @__PURE__ */ import_react.default.createElement("div", { className: "v2-mr-2.5 v2-self-center v2-text-xs v2-text-neutral-300 v2-min-w-[70px]" }, date)
  );
}
